<template>
  <div class="services_page1">
    <Title :msg="title"></Title>
    <grayNumber/>
    <Fixedbg :pic="titleBackground">
      <h1 slot="title">This is a big title.</h1>
      <h2 slot="subtitle">This is a big title2.</h2>
      <h3 slot="content">welcome</h3>
      <template slot="btn">button</template>
    </Fixedbg>
    <Award/>
  </div>
</template>
<script>
// @ is an alias to /src
import Title from '@/components/title_nobg.vue';
import grayNumber from '@/components/grayNumber_area.vue';
import Fixedbg from '@/components/Area_fixedbg.vue';
import Award from '@/components/Award_area.vue';

export default {
  data() {
    return {
      title: 'services_page1',
      titleBackground: {
        url: 'https://picsum.photos/600/300?random=11',
        fixed: true,
      },
    };
  },
  components: {
    grayNumber,
    Title,
    Fixedbg,
    Award,
  },
};
</script>

<style scoped lang="scss">

</style>
